import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
import callApi from "../../helpers/CallApi";
import { logout as logoutApi } from "../../helpers/API";

const Logout = () => {
  const [isLoggedOut, setIsLoggedOut] = React.useState(false);

  const clearStorage = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("accessTokenExpires");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("refreshTokenExpires");
    localStorage.removeItem("user");
  };

  useEffect(() => {
    const refreshToken = localStorage.getItem("refreshToken");
    if (!refreshToken) {
      clearStorage();
      setIsLoggedOut(true);
      return;
    }

    callApi({
      callback: logoutApi,
      payload: { refreshToken },
      onSuccess: () => {
        clearStorage();
        setIsLoggedOut(true);
      },
      onError: () => {
        clearStorage();
        setIsLoggedOut(true);
      },
    });
  }, []);

  if (isLoggedOut) {
    return <Navigate to="/login" />;
  }

  return <></>;
};

export default Logout;
